import LetterHistory from './LetterHistory.jsx';

export default LetterHistory;


// WEBPACK FOOTER //
// ./src/components/modules/letter-history/index.js